/**
 * When the app is live we can use the non sandbox url
 * import { ENV } from "../env";
 * const DOCUSIGN_APP_ROOT =
 *   process.env.NODE_ENV === ENV.PRODUCTION
 *     ? "https://app.docusign.com"
 *     : "https://appdemo.docusign.com";
 */
const DOCUSIGN_APP_ROOT = "https://appdemo.docusign.com";
export const DOCUSIGN_HOME_URL = `${DOCUSIGN_APP_ROOT}/home`;
export const DOCUSIGN_TEMPLATES_URL = `${DOCUSIGN_APP_ROOT}/templates`;
export const DOCUSIGN_ADMIN_URL = "https://admin.docusign.com/admin-dashboard";

export const getDocusignTemplateUrl = (id) =>
  `${DOCUSIGN_APP_ROOT}/templates/details/${id}`;

export const getDocusignTemplateEditorUrl = (id) =>
  `${DOCUSIGN_APP_ROOT}/prepare-template/${id}/add-fields`;
